// export const BASEURL = process.env.REACT_APP_SERVICE_URL;
export const IMAGEPATH = process.env.IMAGE_BASE_URL;
export const SERVERURL = process.env.REACT_APP_SERVICE_URL;
export const SERVICE_NAME = 'data_service.php?service';
export const BASEURL = `${SERVERURL}local/aceexam_api`;
export const MOODLE_SERVICE = 'moodle_mobile_app';
export const PANEL = 'teacher';
